export enum IOC_TYPES {
  MD5 = 'sample',
  SHA256 = 'sha256',
  URL = 'url',
  IP = 'ip',
  DOMAIN = 'domain',
  REGISTRY_KEY = 'registry',
  DROPPED_FILE_NAMES = 'file_name',
  PROCESS_NAMES = 'process',
}

export enum INLINE_ACTIONS {
  COPY = 'copy',
  SEARCH = 'search',
  INCIDENTS = 'incidents',
  INTELLIZONE = 'intellizone'
}
